import { authRoles } from './auth/authRoles'
import React from 'react'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';

import DvrIcon from '@material-ui/icons/Dvr';
import CategoryIcon from '@material-ui/icons/Category';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AirlineSeatIndividualSuiteIcon from '@mui/icons-material/AirlineSeatIndividualSuite';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import DinnerDiningOutlinedIcon from '@mui/icons-material/DinnerDiningOutlined';
import KingBedOutlinedIcon from '@mui/icons-material/KingBedOutlined';
import PollIcon from '@mui/icons-material/Poll';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PaymentIcon from '@mui/icons-material/Payment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DiscountIcon from '@mui/icons-material/Discount';
import PaidIcon from '@mui/icons-material/Paid';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import Person4Icon from '@mui/icons-material/Person4';

export const navigations = [
    {
        name: 'Dashboard',
        path: '/dashboard',
        icon: <HomeOutlinedIcon />,
        auth: [...authRoles.super_admin, ...authRoles.hotel_owner, ...authRoles.agent],
    },
    {
        name: 'Hotels',
        icon: <CorporateFareIcon />,
        path: '/admin_all_holels',
        auth: authRoles.super_admin,
    },

    // common views
    {
        name: 'Payouts',
        icon: <PaymentIcon />,
        children: [
            {
                name: 'Payouts All',
                path: '/HotelOwnerPayouts',
                auth: authRoles.super_admin,
            },
            {
                name: 'Hotel Vise',
                path: '/payoutsMainView',
                auth: authRoles.super_admin,
            },
            
        ]
    },
   

    // hotel owner
    {
        name: 'Booking',
        icon: <PollIcon />,
        path: '/booking_list',
        auth: authRoles.booking,
    },
    {
        name: 'Hotels',
        icon: <CorporateFareIcon />,
        path: '/owner_hotels',
        auth: authRoles.hotel_owner,
    },
     {
        name: 'Payouts',
        icon: <PaymentIcon />,
        path: '/HotelOwnerPayouts',
        auth: authRoles.hotel_owner,
    },

       {
        name: 'Payout Settlements',
        icon: <AttachMoneyIcon />,
        path: '/payoutsSettlements',
        auth: authRoles.control,
    },
       {
        name: 'Discount',
        icon: <DiscountIcon />,
        path: '/discountsSetup',
        auth: authRoles.hotel_owner,
    },
    
     {
        name: 'Calender',
        icon: <CalendarMonthIcon />,
        path: '/calender',
        auth: authRoles.hotel_owner,
    },
    

    // asmin property setups
    
 
    {
        name: 'Discount',
        icon: <DiscountIcon />,
        path: '/admin/discounts',
        auth: authRoles.super_admin,
    },
       {
        name: 'Agent',
        icon: <Person4Icon />,
        children: [
            {
                name: 'Agent Request',
                path: '/admin/agent',
                auth: authRoles.super_admin,
            },
            {
                name: 'Agent Earning',
                path: '/agent_income',
                auth: authRoles.super_admin,
            },
            {
                name: 'Agent Commission',
                path: '/admin/agent_commission',
                auth: authRoles.super_admin,
            },
            
        ]
    },
    {
        name: 'Agent Earning',
        icon: <PaidIcon />,
        path: '/agent_income',
        auth: authRoles.agent,
    },
    {
        name: 'Property Setup',
        icon: <DvrIcon />,
        path: '/adminPropertySetup',
        auth: authRoles.super_admin,
    },
    {
        name: 'Hotel Category',
        icon: <CategoryIcon />,
        path: '/adminCategorySetup',
        auth: authRoles.super_admin,
    },
    {
        name: 'Wellness Packages',
        icon: <Inventory2Icon />,
        path: '/adminWellnessPackagesSetup',
        auth: authRoles.super_admin,
    },
    {
        name: 'Room Types',
        icon: <AirlineSeatIndividualSuiteIcon />,
        path: '/adminRoomTypeSetup',
        auth: authRoles.super_admin,
    },
    {
        name: 'Bed Types',
        icon: <KingBedOutlinedIcon />,
        path: '/adminBedTypeSetup',
        auth: authRoles.super_admin,
    },
    {
        name: 'Meal Plans',
        icon: <DinnerDiningOutlinedIcon />,
        path: '/adminMealPalnesSetup',
        auth: authRoles.super_admin,
    },



    //    Agent 
    
    {
        name: 'Document Uploads',
        icon: <DocumentScannerIcon />,
        path: '/file_upload',
        auth: authRoles.agent,
    },
    
]

//for  icon refference
//https://fonts.google.com/icons?selected=Material+Icons:delivery_dining:&icon.style=Filled&icon.set=Material+Icons